/**
 * Created by HYL.
 * 区域相关api
 */
import * as API from './'

export default {

  // 层级区域列表接口
  childrens: code => {
    return API.GET('/api/region/children/' + code)
  } 
}



// WEBPACK FOOTER //
// ./src/api/api_region.js